import React, { ReactNode } from "react";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import drawerAiEditLockStyles from "./drawerAiEditLockStyles";

type DrawerAiEditLockProps = {
  locked: boolean;
  //shown in the overlay, e.g. "LEXA arbeitet…" — neutral wording because a prompt may not change the payload
  label: string;
  children: ReactNode;
};

//locks the drawer content while an edit prompt for the open step is running: the AI answer may remount
//the form with a fresh payload, so user input is blocked (inert covers clicks AND keyboard/focus) instead
//of being silently overwritten. The wrapper structure stays identical in both states so React never
//remounts the children when the lock toggles.
export default function DrawerAiEditLock({ locked, label, children }: DrawerAiEditLockProps) {
  return (
    <Box sx={{ position: "relative" }}>
      <Box inert={locked}>{children}</Box>
      {locked && (
        <Stack direction={"row"} spacing={1} sx={drawerAiEditLockStyles.overlay}>
          <CircularProgress size={20} />
          <Typography variant={"body2"}>{label}</Typography>
        </Stack>
      )}
    </Box>
  );
}
